<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="race_owner_type_cd_obj.label"
          />
        </div>
        <div class="col-2">
          <label for="RaceOwnerTypeCd" class="form-label">コード</label>
          <input
            type="text"
            class="form-control"
            id="RaceOwnerTypeCd"
            placeholder="コード"
            v-model="race_owner_type_cd_obj.race_owner_type_cd"
          />
        </div>
        <div class="col-4">
          <label for="ShortLabel" class="form-label">グレード</label>
          <bs-select
            :options="race_owner_type_grade_list"
            v-model="race_owner_type_cd_obj.grade"
            :null-option="true"
            id="MainClinicId"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="race_owner_type_cd_obj.sort"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'

export default {
  name: 'RaceOwnerTypeCdDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '種目コードマスタデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      race_owner_type_cd_obj: {},
      race_owner_type_grade_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadRaceOwnerTypeCdObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_owner_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceOwnerTypeCdObj', response)
          this.race_owner_type_cd_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.race_owner_type_cd_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.race_owner_type_cd_obj)
      return this.$store
        .dispatch('updateBasic', {
          data: this.race_owner_type_cd_obj,
          target: 'race_owner_type_cd'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadRaceOwnerTypeCdObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    race_owner_type_grade_list: function () {
      return this.race_owner_type_grade_obj
    }
  },

  async created() {
    this.race_owner_type_grade_obj = await this.getConfigAPI(
      'race_owner_type_grade'
    )
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadRaceOwnerTypeCdObj()
      this.btnLabel = '更新'
    } else {
      this.race_owner_type_cd_obj = {
        id: 0,
        label: '',
        race_owner_type_cd: '',
        grade: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'イベント種目データ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
